import { Box, Stack } from "@mui/material";
import {
  ActivityStatus,
  ExecutionPlanType,
  GetTierIiReportQuery,
} from "generated-graphql/graphql";
import { SendToErrorTriage } from "./SendToErrorTriage";
import { CompleteActivity } from "./CompleteActivity";
import { SetToManual } from "./SetToManual";
import { Requeue } from "./Requeue";

type ActivityBottomToolbarProps = {
  activity: NonNullable<
    GetTierIiReportQuery["tierIIReport"]["currentWorkflow"]
  >["activities"][0];
};

export function ActivityBottomToolbar({
  activity,
}: ActivityBottomToolbarProps) {
  // At this point, we are enabling completion whenever an
  // activity is considered "current", that is, it is not
  // in these statuses
  const isCurrent = ![
    ActivityStatus.NotStarted,
    ActivityStatus.StaffCompleted,
    ActivityStatus.Completed,
  ].includes(activity?.status);

  const canRequeue = activity?.status === ActivityStatus.Error;
  const skipResumeDialog = activity?.executionPlan === ExecutionPlanType.Human;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        justifyContent: "space-between",
        alignItems: "flex-start",
        "@media (max-width: 600px)": {
          flexDirection: "column",
          gap: 2,
        },
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          flexWrap: "wrap",
          gap: 1,
          "@media (max-width: 600px)": {
            width: "100%",
            justifyContent: "center",
          },
        }}
      >
        <SetToManual activity={activity} />
        {canRequeue && (
          <Requeue activity={activity} showWarningPanel={!skipResumeDialog} />
        )}
        <SendToErrorTriage activity={activity} />
      </Stack>
      <Box
        sx={{
          "@media (max-width: 600px)": {
            width: "100%",
            display: "flex",
            justifyContent: "center",
          },
        }}
      >
        {isCurrent && (
          <CompleteActivity
            activity={activity}
            showWarningPanel={
              activity?.status === ActivityStatus.Error ||
              activity.executionPlan === ExecutionPlanType.Automation
            }
          />
        )}
      </Box>
    </Box>
  );
}

export type ActivityButtonProps = {
  activity: ActivityBottomToolbarProps["activity"];
};
